import LocomotiveScroll from 'locomotive-scroll';

export default function () {
	if ('IntersectionObserver' in window) {
		const body = document.querySelector('body');
		const siteHeader = document.querySelector('.site-header');
		const siteHeaderAnchor = document.querySelector('#site-header-anchor');

		const filterByCall = (name) => {
			return (obj) => {
				if (obj.call) {
					return obj.call.includes(name);
				}
			};
		};

		// Initiate LocomotiveScroll. Repeat all scroll events for animation. The offset is set manually
		const scroll = new LocomotiveScroll({
			getDirection: true,
			offset: ['20%', 0],
			repeat: true,
		});

		scroll.on('scroll', (obj) => {
			// Get all the scroll elements.
			const elements = Object.values(obj.currentElements);

			// Get all the elements that have the background callback function.
			const backgroundElements = elements.filter(
				filterByCall('background')
			);

			// get all the elements that have the fullwidth-animated callback function.
			const fullwidthAnimated = elements.filter(
				filterByCall('fullwidth-animated')
			);

			// get all the elements that have the two-column-list callback function.
			const twoColumnList = elements.filter(
				filterByCall('two-column-list')
			);

			// get all the elements that have the slice-reveal callback function.
			const sliceReveal = elements.filter(filterByCall('slice-reveal'));

			// Add a scrolled class for animation purposes. Needed since Locomotive is set to repeat.
			elements.forEach((element) => {
				if (
					// element.progress > 0.15 &&
					!element.el.classList.contains('is-scrolled')
				) {
					element.el.classList.add('is-scrolled');
				}
			});

			// Set background color
			if (backgroundElements.length === 0) {
				// Remove the data-background attribute if there's none in the viewport.
				body.removeAttribute('data-background');
			} else {
				// When there's one or multiple backgrounds in view, set the lat one as the background.
				const lastBackground = backgroundElements.pop();
				body.setAttribute(
					'data-background',
					lastBackground.el.getAttribute('data-scroll-bg')
				);
			}

			// Run the animation for all Fullwidth Animation element.
			fullwidthAnimated.forEach((element) => {
				if (
					element.progress > 0.3 &&
					!element.el.classList.contains('is-revealed')
				) {
					element.el.classList.add('is-revealed');
				}

				if (element.progress > 0.75) {
					element.el.classList.add('has-scrolled');
				} else {
					element.el.classList.remove('has-scrolled');
				}
			});

			// Run the animation for all Fullwidth Animation element.
			sliceReveal.forEach((element) => {
				if (
					element.progress > 0.25 &&
					!element.el.classList.contains('is-revealed')
				) {
					element.el.classList.add('is-revealed');
				}
			});

			// Run animations for two column list.
			twoColumnList.forEach((element) => {
				const listItems = element.el.querySelectorAll('li');
				const numberListItem = listItems.length;

				listItems.forEach((item, index) => {
					const minRange = (1 / numberListItem) * index;
					const maxRange = (1 / numberListItem) * (index + 1);
					item.classList.remove('is-active');
					if (
						element.progress >= minRange &&
						element.progress <= maxRange
					) {
						item.classList.add('is-active');
					}
				});
			});

			// Set the scroll data-direction on the body.
			body.setAttribute('data-direction', obj.direction);
		});

		// Find the first element child of the scroll content container and add class to trigger the animation.
		// This replaces a window scroll trigger since it wasn't working on all devices.
		const scrollElement = document.querySelector('.js-scroll-content');
		if (
			scrollElement &&
			scrollElement.firstElementChild.hasAttribute('data-scroll')
		) {
			scrollElement.firstElementChild.classList.add('is-scrolled');
		}

		// Create an intersection observer for the site header anchor.
		const siteHeaderObserverCallback = (entries) => {
			// Add or remove the sitcky class depending if site header anchor is visible or not.
			if (entries[0].intersectionRatio === 0) {
				siteHeader.classList.add('is-sticky');
			} else {
				siteHeader.classList.remove('is-sticky');
			}
		};
		const siteHeaderObserver = new window.IntersectionObserver(
			siteHeaderObserverCallback
		);
		siteHeaderObserver.observe(siteHeaderAnchor);
	}
}
